(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('RealtyTypeSearch', RealtyTypeSearch);

    RealtyTypeSearch.$inject = ['$resource'];

    function RealtyTypeSearch($resource) {
        var resourceUrl =  'api/_search/realty-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
